import { autoserialize } from 'cerialize';

export class StandardDonationItem implements IStandardDonationItem {
  @autoserialize id?: string;
  @autoserialize name?: string;
  @autoserialize type?: string;
  @autoserialize version?: string;
  @autoserialize price?: number;
  @autoserialize value?: number;
  @autoserialize small?: number;
  @autoserialize medium?: number;
  @autoserialize large?: number;
  @autoserialize xlarge?: number;
  @autoserialize recycling?: number;
  @autoserialize specialty?: number;
  @autoserialize restricted?: boolean;
  @autoserialize icon_url?: string;
  @autoserialize photo_url?: string;

  constructor(payload?: IStandardDonationItem) {
    this.id = payload?.id?.toString();
    this.name = payload?.name;
    this.type = payload?.type;
    this.version = payload?.version;
    this.price = payload?.price;
    this.value = payload?.value;
    this.small = payload?.small;
    this.medium = payload?.medium;
    this.large = payload?.large;
    this.xlarge = payload?.xlarge;
    this.recycling = payload?.recycling;
    this.specialty = payload?.specialty;
    this.restricted = payload?.restricted;
    this.icon_url = payload?.icon_url;
    this.photo_url = payload?.photo_url;
  }
}

export interface IStandardDonationItem {
  id?: string;
  name?: string;
  type?: string;
  version?: string;
  price?: number;
  value?: number;
  small?: number;
  medium?: number;
  large?: number;
  xlarge?: number;
  recycling?: number;
  specialty?: number;
  restricted?: boolean;
  icon_url?: string;
  photo_url?: string;
}
